import Vue from "vue";
import { createHead } from "@unhead/vue";

const head = createHead();

Vue.use(head);
